import { SVGProps } from 'react';

export const VendorsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="68"
    height="69"
    viewBox="0 0 68 69"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3949 12.8509H20.623L16.2093 28.3051H7.77123L14.3949 12.8509ZM37.1041 12.8509H40.9553L45.369 28.3051H37.1041V12.8509ZM22.6462 28.3051L27.06 12.8509H30.9112V28.3051H22.6462ZM60.2082 28.3051H51.7733L47.3596 12.8509H53.5876L60.2082 28.3051ZM30.9235 53.047H15.4693V40.6836H30.9235V53.047ZM67.749 30.1926L58.4764 8.55665C57.9912 7.41922 56.8723 6.68359 55.636 6.68359H12.364C11.1277 6.68359 10.0088 7.41922 9.52355 8.55665L0.251002 30.1926C-0.160082 31.1477 -0.0611743 32.2449 0.510633 33.1135C1.08244 33.982 2.05297 34.5012 3.09149 34.5012H6.18234V59.2281C6.18234 60.9342 7.56704 62.3189 9.27319 62.3189H40.1817V40.6829H52.5451V62.3189H58.7268C60.433 62.3189 61.8177 60.9342 61.8177 59.2281V34.5012H64.9085C65.947 34.5012 66.9176 33.982 67.4894 33.1135C68.0612 32.2449 68.1601 31.1477 67.749 30.1926Z"
      fill="currentColor"
    />
  </svg>
);
